export default __webpack_public_path__ + "static/media/sirange.4a855ba2.svg";